export class BaseChargeModel {
    base_charge_code: string
    base_charge_price: number
    base_charge_desc: string

    private _header: string

    public get header(): string {
        return `${this.base_charge_code} -- $${this.base_charge_price}`;
    }

    public set header(header: string) {
        this._header = header;
    }


    constructor(
        base_charge_code: string,
        base_charge_price: number,
        base_charge_desc: string
    ) {
        this.base_charge_code = base_charge_code
        this.base_charge_price = base_charge_price
        this.base_charge_desc = base_charge_desc
    }
}